import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Loading from '../Components/Loading';

const WorkLocationMap = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [mapData, setMapData] = useState(null);

  useEffect(() => {
    // Get location data from navigation state or fetch from API
    if (location.state) {
      setMapData(location.state);
      setLoading(false);
    } else {
      // If no state, try to fetch from API or show error
      setLoading(false);
    }
  }, [location.state]);

  const handleBack = () => {
    navigate('/work-location');
  };

  if (loading) {
    return (
      <div className="employee-form">
        <section className="content">
          <div className="container-fluid">
            <Loading size={120} />
          </div>
        </section>
      </div>
    );
  }

  if (!mapData || !mapData.latitude || !mapData.longitude) {
    return (
      <div className="employee-form">
        <section className="content">
          <div className="container-fluid">
            <div className="row mb-3 employee-header-row">
              <div className="col-md-12">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleBack}
                  style={{ marginBottom: '20px' }}
                >
                  <i className="fas fa-arrow-left mr-2"></i>
                  Back to Work Locations
                </button>
                <div className="alert alert-danger">
                  Location coordinates are missing. Please check the work location details.
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  // Google Maps embed URL
  const googleMapsUrl = `https://www.google.com/maps?q=${mapData.latitude},${mapData.longitude}&z=15&output=embed`;
  // Alternative: Open in new tab
  const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${mapData.latitude},${mapData.longitude}`;

  return (
    <div className="employee-form">
      <section className="content">
        <div className="container-fluid">
          {/* Header */}
          <div className="row mb-3 employee-header-row">
            <div className="col-md-8">
              <h1 className="employee-title">
                {mapData.locationName || 'Work Location'} on Map
                <i className="fas fa-info-circle ml-2 employee-title-icon"></i>
              </h1>
              <p className="employee-description">
                View the work location on the map. Coordinates: {mapData.latitude}, {mapData.longitude}
              </p>
            </div>
            <div className="col-md-4 employee-view-header-actions">
              <button type="button" className="employee-back-btn" onClick={handleBack}>
                <i className="fas fa-arrow-left mr-2"></i>
                Back to Work Locations
              </button>
            </div>
          </div>

          {/* Map Container */}
          <div className="card employee-content-card">
            <div className="card-body">
              <div style={{ position: 'relative', width: '100%', height: '400px', marginBottom: '20px' }}>
                <iframe
                  width="100%"
                  height="100%"
                  style={{ border: 0, borderRadius: '8px' }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  src={googleMapsUrl}
                  title={`Map view for ${mapData.locationName}`}
                ></iframe>
              </div>
              
              <div className="d-flex flex-wrap" style={{ gap: '12px' }}>
                <a
                  href={googleMapsLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary"
                  style={{ backgroundColor: '#0094a9', borderColor: '#0094a9' }}
                >
                  <i className="fas fa-external-link-alt mr-2"></i>
                  Open in Google Maps
                </a>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleBack}
                >
                  <i className="fas fa-arrow-left mr-2"></i>
                  Back to List
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WorkLocationMap;

